module.exports = __webpack_public_path__ + "static/media/vi.9089b8e3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vi.svg
// module id = 1063
// module chunks = 0